export const rolesEnum = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  USER: 'user',
};

export const isAdmin = (role) => [rolesEnum.SUPERADMIN, rolesEnum.ADMIN].includes(role);
